<div class="my-4 bg-card shadow rounded-2xl p-4">
    <fuse-alert
        class="my-4"
        *ngIf="showAlertCreateOrUpdateContract"
        [dismissed]="!showAlertCreateOrUpdateContract"
        [dismissible]="true"
        [appearance]="'outline'"
        [showIcon]="true"
        [type]="alertCreateOrUpdateContract.type"
        [@shake]="alertCreateOrUpdateContract.type === 'error'">
        {{ alertCreateOrUpdateContract.message }}
    </fuse-alert>
    <fuse-alert
        class="my-4"
        *ngIf="showAlertDownloadContract"
        [dismissed]="!showAlertDownloadContract"
        [dismissible]="true"
        [appearance]="'outline'"
        [showIcon]="true"
        [type]="alertDownloadContract.type"
        [@shake]="alertDownloadContract.type === 'error'">
        {{ alertDownloadContract.message }}
    </fuse-alert>
    <fuse-alert
        class="my-4"
        *ngIf="showAlertSetRpStatus"
        [dismissed]="!showAlertSetRpStatus"
        [dismissible]="true"
        [appearance]="'outline'"
        [showIcon]="true"
        [type]="alertRpStatus.type"
        [@shake]="alertRpStatus.type === 'error'">
        {{ alertRpStatus.message }}
    </fuse-alert>
    <fuse-alert
        class="my-4"
        *ngIf="showAlertDeleteContract"
        [dismissed]="!showAlertDeleteContract"
        [dismissible]="true"
        [appearance]="'outline'"
        [showIcon]="true"
        [type]="alertDeleteContract.type"
        [@shake]="alertDeleteContract.type === 'error'">
        {{ alertDeleteContract.message }}
    </fuse-alert>
    <div class="flex items-center justify-between mb-4">
        <div class="text-xl">Contratos</div>
        <button mat-raised-button color="primary"
                *ngIf="user.rol !== accountRole.provider && user.canEdit"
                (click)="openToggleContractFormDialogTemplate()">
            <mat-icon class="mr-2">upload_file</mat-icon>
            Cargar contrato
        </button>
    </div>
    <div class="overflow-auto">
        <table mat-table [dataSource]="contracts" matSort>
            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>Acciones</th>
                <td mat-cell *matCellDef="let contract">
                    <div class="flex flex-row gap-0 ">
                        <button mat-icon-button color="primary"
                                *ngIf="canSeeContractEvidences() && contract.contractImssRegistries?.length"
                                matTooltip="Revisar información del contrato"
                                [routerLink]="'/providers/hotels/'+contracteeId+'/'+contractor.providerId+'/'+contract.contractImssRegistries[0].id">
                            <mat-icon fontSet="material-symbols-outlined">folder_open</mat-icon>
                        </button>
                        <button mat-icon-button color="primary"
                                *ngIf="isFianzasEnabled"
                                matTooltip="Ver fianzas del contrato"
                                (click)="openFianzasDialog(contract)">
                            <mat-icon fontSet="material-symbols-outlined">verified_user</mat-icon>
                        </button>
                        <button mat-icon-button color="primary"
                                [disabled]="contract.path === null"
                                [ngClass]="contract.path === null ? 'intermitente text-red-400 italic px-2 py-0' : ''"
                                [matTooltip]="contract.path === null ?
                                 'El contrato no tiene un documento cargado, agregelo lo antes posible en la sección de edición del contrato' :
                                  'Descargar contrato'"
                                (click)="downloadContract(contract.path)">
                            <mat-icon>cloud_download</mat-icon>
                        </button>
                        <button mat-icon-button color="primary"
                                *ngIf="user.rol !== accountRole.provider && user.canEdit"
                                matTooltip="Editar contrato"
                                (click)="openToggleContractFormDialogTemplate(contract)">
                            <mat-icon fontSet="material-symbols-outlined">contract_edit</mat-icon>
                        </button>
                        <button mat-icon-button color="warn"
                                *ngIf="user.rol === accountRole.master"
                                matTooltip="Eliminar contrato"
                                (click)="deleteContract(contract)">
                            <mat-icon fontSet="material-symbols-outlined">contract_delete</mat-icon>
                        </button>
                    </div>
                </td>
            </ng-container>
            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef>Estatus</th>
                <td mat-cell *matCellDef="let contract">
                    <div class="flex" [ngClass]="{'justify-center': user.rol !== accountRole.provider}">
                        <mat-icon [ngStyle]="{color: getStatusColor(contract.status.id)}"
                                  matTooltip="{{ getStatusLabel(contract.status.id) }}">
                            circle
                        </mat-icon>
                    </div>
                </td>
            </ng-container>
            <ng-container matColumnDef="tag">
                <th mat-header-cell *matHeaderCellDef class="min-w-[100px]" mat-sort-header>Folio</th>
                <td mat-cell *matCellDef="let contract" class="font-bold">{{ contract.tag }}</td>
            </ng-container>
            <ng-container matColumnDef="startDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Inicio</th>
                <td mat-cell *matCellDef="let contract" class="whitespace-nowrap">{{ contract.startDate | date }}</td>
            </ng-container>
            <ng-container matColumnDef="endDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Fin</th>
                <td mat-cell *matCellDef="let contract" class="whitespace-nowrap">{{ contract.endDate | date }}</td>
            </ng-container>
            <ng-container matColumnDef="rp">
                <th mat-header-cell *matHeaderCellDef>Registro Patronal</th>
                <td mat-cell *matCellDef="let contract">
                    <ng-container *ngIf="user.rol !== accountRole.provider; else providerRp">
                        <ng-container
                            *ngIf="!contract.contractImssRegistries?.at(0)?.imssEmployerRegistryId; else showRp">
                            <button
                                *ngIf="contract.isImssEmployerRegistryRequested !== rpStatus.rpPending; else requestedRp"
                                mat-stroked-button dense
                                class="text-red-400 italic px-2 py-0"
                                (click)="modifyRpStatus(contract.id, rpStatus.rpPending)"
                                matTooltip="Este contrato no cuenta con Registro Patronal. Al hacer clic se enviará una
                                 solicitud al proveedor para agregar el Registro correspodiente.">
                                Sin Registro Patronal
                            </button>
                            <ng-template #requestedRp>
                                <button mat-stroked-button
                                        class="text-yellow-400 italic px-2"
                                        (click)="modifyRpStatus(contract.id, rpStatus.withoutRp)"
                                        matTooltip="Se ha enviado una solicitud al proveedor, al dar clic se cancelará.">
                                    Solicitud enviada
                                </button>
                            </ng-template>
                        </ng-container>
                        <ng-template #showRp>
                            <div class="flex items-center gap-1">
                                <span>{{ contract.imssEmployerRegistries.at(0)?.rp }}</span>
                                <button mat-icon-button color="primary"
                                        [disabled]="!getLinkedRegistry(contract)?.altaPatronalUrl"
                                        [matTooltip]="getLinkedRegistry(contract)?.altaPatronalUrl ? 'Descargar Tarjeta Patronal' : 'Sin documento adjunto'"
                                        class="icon-size-5"
                                        (click)="downloadTarjetaPatronal(contract)">
                                    <mat-icon class="icon-size-5">cloud_download</mat-icon>
                                </button>
                            </div>
                        </ng-template>
                    </ng-container>
                    <ng-template #providerRp>
                        <ng-container
                            *ngIf="contract.contractImssRegistries?.at(0)?.imssEmployerRegistryId; else noRpProvider">
                            {{ contract.imssEmployerRegistries.at(0)?.rp }}
                        </ng-container>
                        <ng-template #noRpProvider>
                            <button
                                *ngIf="contract.isImssEmployerRegistryRequested === rpStatus.rpPending; else hasNoRp"
                                mat-stroked-button
                                class="intermitente text-red-400 italic px-2 py-0"
                                (click)="openToggleAddRpToContractDialogTemplate(contract)"
                                matTooltip="El contratista ha solicitado agregar un registro patronal. Haz clic para agregarlo.">
                                Selecciona un RP
                            </button>
                            <ng-template #hasNoRp>
                                <button mat-stroked-button
                                        class="text-yellow-400 italic px-2 py-0"
                                        (click)="openToggleAddRpToContractDialogTemplate(contract)"
                                        matTooltip="Este contrato no cuenta con registro patronal, Haz clic para agregarlo.">
                                    Sin RP
                                </button>
                            </ng-template>
                        </ng-template>
                    </ng-template>
                </td>
            </ng-container>
            <ng-container matColumnDef="region">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Región</th>
                <td mat-cell *matCellDef="let contract">{{ contract.region?.name }}</td>
            </ng-container>
            <ng-container matColumnDef="uuid">
                <th mat-header-cell *matHeaderCellDef class="min-w-[100px]" mat-sort-header>Id</th>
                <td mat-cell *matCellDef="let contract" class="whitespace-nowrap">{{ contract.uuid }}</td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            <tr class="mat-row" *matNoDataRow>
                <td [colSpan]="displayedColumns.length" class="text-center py-8 text-secondary">
                    <mat-icon class="text-4xl mb-2 opacity-30">description</mat-icon>
                    <p>No hay contratos registrados</p>
                </td>
            </tr>
        </table>
    </div>
    <mat-paginator [pageSizeOptions]="[5, 10, 20]"
                   [pageSize]="5"
                   [length]="totalContracts"
                   showFirstLastButtons
                   aria-label="Selector de página">
    </mat-paginator>
</div>
<ng-template #fianzasDialogTemplate>
    <h2 mat-dialog-title>Fianzas del contrato</h2>
    <mat-dialog-content class="min-h-[300px]">
        <app-fianzas [contractUuid]="selectedContractUuid"
                     [providerName]="$safeNavigationMigration(contractor?.businessName)"
                     [companyName]="contracteeName"
                     [contractTag]="selectedContractTag"></app-fianzas>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button class="ml-auto" mat-button [mat-dialog-close]="false">Cerrar</button>
    </mat-dialog-actions>
</ng-template>
<ng-template #toggleContractFormDialogTemplate let-contract>
    <h2 mat-dialog-title>
        {{ contract ? 'Editar contrato' : 'Agregar nuevo contrato' }}
    </h2>
    <fuse-alert
        class="m-3"
        *ngIf="contract"
        appearance="outline"
        [showIcon]="true"
        type="info">
        Info: Si no cargas un nuevo archivo de contrato, el contrato actual se mantiene. Para actualizarlo, es necesario
        cargar el nuevo archivo.
    </fuse-alert>
    <div class="relative isolate flex min-h-0 flex-col" [attr.aria-busy]="isSubmitting">
    <mat-dialog-content>
        <form [formGroup]="contractForm">
            <div class="grid grid-cols-2 grid-rows-3 gap-4 px-5 pt-4">
                <div>
                    <mat-form-field class="w-full">
                        <mat-label>Contrato .pdf</mat-label>
                        <ngx-mat-file-input formControlName="file" accept=".pdf" placeholder="Contrato">
                        </ngx-mat-file-input>
                        <mat-error
                            *ngIf="contractForm.controls['file'].hasError('maxContentSize')">
                            El contrato no puede pesar más de
                            <strong>
                                {{ $safeNavigationMigration(contractForm.controls['file'].errors?.maxContentSize.maxSize) | byteFormat }}
                                ({{ $safeNavigationMigration(contractForm.controls['file'].errors?.maxContentSize.actualSize) | byteFormat }})
                            </strong>
                        </mat-error>
                    </mat-form-field>
                </div>
                <div>
                    <mat-form-field class="w-full">
                        <mat-label>Folio</mat-label>
                        <input matInput type="text" formControlName="tag" placeholder="Folio del contrato"
                               maxlength="30">
                        <mat-error *ngIf="contractForm.get('tag').hasError('maxlength')">
                            El folio no puede tener más de 30 caracteres
                        </mat-error>
                    </mat-form-field>
                </div>
                <div>
                    <mat-form-field class="w-full">
                        <mat-label>Fecha inicial</mat-label>
                        <input matInput [min]="minDate" [max]="maxDate" [matDatepicker]="startDate"
                               formControlName="startDate" placeholder="Fecha de inicio">
                        <mat-datepicker-toggle matSuffix [for]="startDate"></mat-datepicker-toggle>
                        <mat-datepicker #startDate></mat-datepicker>
                        <mat-hint>DD/MM/AAAA</mat-hint>
                        <mat-error *ngIf="contractForm.get('startDate').hasError('required')">
                            La fecha de inicio es obligatoria
                        </mat-error>
                    </mat-form-field>
                </div>
                <div>
                    <mat-form-field class="w-full">
                        <mat-label>Fecha final</mat-label>
                        <input matInput [min]="minDate" [max]="maxDate" [matDatepicker]="endDate"
                               formControlName="endDate" placeholder="Fecha final">
                        <mat-datepicker-toggle matSuffix [for]="endDate"></mat-datepicker-toggle>
                        <mat-datepicker #endDate></mat-datepicker>
                        <mat-hint>DD/MM/AAAA</mat-hint>
                        <mat-error *ngIf="contractForm.get('endDate').hasError('required')">
                            La fecha de fin es obligatoria
                        </mat-error>
                    </mat-form-field>
                    <mat-error *ngIf="isDateRangeInvalid">
                        La fecha de fin debe ser posterior a la fecha de inicio.
                    </mat-error>
                </div>
                <div *ngIf="this.isUpdate">
                    <mat-form-field class="w-full mat-form-field-disabled">
                        <mat-label class="pointer-events-auto"
                                   matTooltip="El registro patronal solo puede ser agregado por el proveedor.">
                            Registro patronal
                            <mat-icon class="icon-size-4 text-hint"
                                      svgIcon="heroicons_solid:information-circle"></mat-icon>
                        </mat-label>
                        <input matInput readonly type="text" formControlName="rp" placeholder="Sin registro patronal">
                    </mat-form-field>
                </div>
                <div>
                    <mat-error *ngIf="contractForm.get('region').hasError('min')">
                        Debes terminar de crear la región, o seleccionar una ya existente.
                    </mat-error>
                    <app-region-selector [contracteeId]="contracteeId" formControlName="region"></app-region-selector>
                </div>
                <div class="flex items-center" *ngIf="!contract?.rp">
                    <mat-checkbox formControlName="isImssEmployerRegistryRequested" color="primary">
                        ¿Solicitar el Registro Patronal al proveedor?
                    </mat-checkbox>
                </div>
                <div>
                    <mat-form-field class="w-full">
                        <mat-label>Estatus del contrato</mat-label>
                        <mat-select formControlName="status" placeholder="Selecciona un estatus">
                            <mat-option *ngFor="let status of contractStatusList" [value]="status.id">
                                {{ status.name }}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="contractForm.get('status').hasError('required')">
                            El estatus es obligatorio
                        </mat-error>
                    </mat-form-field>
                </div>
                <div>
                    <mat-form-field class="w-full">
                        <mat-label>Monto</mat-label>
                        <input matInput type="text" formControlName="amount" placeholder="Monto del contrato"
                               currencyMask>
                        <mat-error *ngIf="contractForm.get('amount').hasError('min')">
                            El monto no puede ser negativo
                        </mat-error>
                        <mat-error *ngIf="contractForm.get('amount').hasError('max')">
                            El monto no puede se mayor a {{ contractForm.get('amount').errors?.max.max }}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div>
                    <mat-form-field class="w-full">
                        <mat-label>Objeto del contrato</mat-label>
                        <input matInput type="text" formControlName="subject" placeholder="Objeto del contrato">
                        <mat-error *ngIf="contractForm.get('subject').hasError('minLength')">
                            El monto debe tener al menos {{ contractForm.get('subject').errors?.requiredLength }}
                            caractéres
                        </mat-error>
                        <mat-error *ngIf="contractForm.get('subject').hasError('maxlength')">
                            El monto no debe tener mas de {{ contractForm.get('subject').errors?.requiredLength }}
                            caractéres
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-span-2 flex flex-col gap-2" *ngIf="isUpdate">
                    <mat-checkbox formControlName="synchronizeEvidenceConfig" color="primary">
                        Sincronizar configuración de evidencias
                    </mat-checkbox>
                    <mat-checkbox
                        *ngIf="contractForm.get('synchronizeEvidenceConfig')?.value"
                        formControlName="recalculateEvidenceSummaries"
                        color="primary">
                        Recalcular resúmenes de evidencias
                    </mat-checkbox>
                </div>
            </div>
        </form>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button class="ml-auto" mat-button [mat-dialog-close]="false">
            Cancelar
        </button>
        <button class="ml-2" color="primary" mat-flat-button
                [disabled]="contractForm.invalid || isSubmitting" (click)="createOrUpdateContract()">
            {{ isSubmitting ? 'Guardando...' : 'Guardar' }}
        </button>
    </mat-dialog-actions>
    <sise-loader
        [active]="isSubmitting"
        [class.pointer-events-auto]="isSubmitting"
        [message]="isUpdate ? 'Actualizando contrato...' : 'Creando contrato...'"></sise-loader>
    </div>
</ng-template>
<ng-template #toggleAddRpToContractDialogTemplate let-contract>
    <h2 mat-dialog-title>Agregar registro patronal</h2>
    <mat-dialog-content>
        <ng-container *ngIf="imssEmployerRegistries.length > 0; else addRp">
            <fuse-alert
                class="mb-4"
                *ngIf="!hasRegistriesWithAltaPatronal"
                appearance="outline"
                [showIcon]="true"
                type="warning">
                Ningún registro patronal tiene Alta Patronal adjunta. Debes subir el documento primero en el módulo
                "Registro Patronal".
            </fuse-alert>
            <form [formGroup]="addRpForm">
                <div class="grid grid-cols-1 gap-4 px-5">
                    <mat-form-field class="w-full">
                        <mat-label>Registro patronal</mat-label>
                        <mat-select formControlName="rp" placeholder="Selecciona un registro patronal">
                            <mat-option *ngFor="let el of imssEmployerRegistries"
                                        [value]="el.id"
                                        [disabled]="!el.altaPatronalUrl">
                                <span class="flex items-center gap-2">
                                    <mat-icon class="icon-size-4"
                                              [class]="el.altaPatronalUrl ? 'text-green-500' : 'text-orange-400'">
                                        {{ el.altaPatronalUrl ? 'check_circle' : 'warning' }}
                                    </mat-icon>
                                    {{ el.rp }}
                                    <span *ngIf="!el.altaPatronalUrl" class="text-xs text-orange-400">(Sin Alta Patronal)</span>
                                </span>
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="addRpForm.get('rp').hasError('required')">
                            El registro patronal es obligatorio
                        </mat-error>
                    </mat-form-field>
                </div>
            </form>
            <div class="fixed inset-0 flex justify-center items-center bg-black bg-opacity-5 z-50"
                 *ngIf="isSubmitting">
                <mat-spinner [diameter]="60"></mat-spinner>
            </div>
        </ng-container>
        <ng-template #addRp>
            <div class="flex flex-col p-6">
                <p class="mb-5">
                    Aún no tienes ningún registro patronal guardado, agregalo en el modúlo "Registro patronal"
                </p>
                <button mat-stroked-button type="button" color="primary" (click)="this.dialog.closeAll()"
                        routerLink="/providers/imss-employer-registry">
                    Ir al modúlo Registro Patronal
                </button>
            </div>
        </ng-template>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button class="ml-auto" mat-button [mat-dialog-close]="false">
            Cancelar
        </button>
        <button class="ml-2" color="primary" mat-flat-button [disabled]="addRpForm.invalid || isSubmitting"
                (click)="addRpToContract($safeNavigationMigration(contract?.id))">
            {{ isSubmitting ? 'Guardando...' : 'Guardar' }}
        </button>
    </mat-dialog-actions>
</ng-template>
